import { useState, useEffect } from 'react';
import api from '../utils/api';

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Check if user is already logged in (JWT token in localStorage)
    api.loadAuth();
    if (api.token) {
      setIsAuthenticated(true);
      // TODO: Fetch user info from token or API
      setUser({ username: 'admin' });
    }
    setIsLoading(false);

    // Token expired/invalid on some API call (401) — kick back to login
    const handleAuthExpired = () => {
      setIsAuthenticated(false);
      setUser(null);
    };
    window.addEventListener('admin-auth-expired', handleAuthExpired);
    return () => window.removeEventListener('admin-auth-expired', handleAuthExpired);
  }, []);

  const login = async (username, password) => {
    try {
      await api.login(username, password);
      setIsAuthenticated(true);
      setUser({ username });
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const logout = () => {
    api.logout();
    setIsAuthenticated(false);
    setUser(null);
  };

  return {
    isAuthenticated,
    isLoading,
    user,
    login,
    logout,
  };
}
